import { render, staticRenderFns } from "./languageSwitcher.vue?vue&type=template&id=40819313&scoped=true&"
import script from "./languageSwitcher.vue?vue&type=script&lang=ts&"
export * from "./languageSwitcher.vue?vue&type=script&lang=ts&"
import style0 from "./languageSwitcher.vue?vue&type=style&index=0&id=40819313&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40819313",
  null
  
)

export default component.exports